var React = require('react');

function FbInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1","y":"1","width":"36","height":"36","rx":"18","stroke":"#262626","strokeWidth":"2","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.528 29.5263H16.1751V19.2619H14V15.7251H16.1751V13.6017C16.1751 10.7166 17.4026 9 20.8924 9H23.797V12.5381H21.9816C20.6231 12.5381 20.5333 13.0323 20.5333 13.9547L20.5273 15.7251H23.8169L23.4319 19.2619H20.5273V29.5263H20.528Z","fill":"#262626","key":1})]);
}

FbInline.defaultProps = {"width":"38","height":"38","viewBox":"0 0 38 38","fill":"none"};

module.exports = FbInline;

FbInline.default = FbInline;
